import * as React from 'react'

import { Box, Button, Icon, Line, Text } from '@factorialco/deprecated-design-system'
import laptopIcon from 'assets/images/laptops-with-charts.svg'

interface Props {
  label: string
  iconUrl?: string
  withHeader?: boolean
  message?: string | React.ReactNode
  illustration?: React.ComponentProps<typeof Icon.Large>['icon']
  withIcon?: boolean
  withLine?: boolean
  actionText?: string
  alignment?: 'center' | 'left' | 'right'
  uploaded?: boolean
  ctaDisabled?: boolean
  action?: () => void
}

const alignItemsProp = (alignment: string) => {
  switch (alignment) {
    case 'left':
      return 'flexStart'
    case 'right':
      return 'flexEnd'
    default:
      return 'center'
  }
}

const BlankSlate = ({
  label,
  iconUrl,
  message,
  illustration,
  withIcon,
  withLine,
  actionText,
  alignment = 'center',
  action,
  uploaded,
  ctaDisabled,
}: Props) => {
  return (
    <Box
      gap="s24"
      alignItems={alignItemsProp(alignment)}
      justifyContent="center"
      flexDirection="column"
      height="full"
      width="full"
    >
      <Box height="fit-content" alignItems="center" justifyContent="center">
        {illustration && <Icon.Large icon={illustration} color="radicalRed1000" />}
        {withIcon && <img src={iconUrl ? iconUrl : laptopIcon} alt={label} />}
      </Box>
      <Box
        gap="s16"
        flexDirection="column"
        justifyContent="center"
        alignItems={alignItemsProp(alignment)}
      >
        <Box flexDirection="column" alignItems={alignItemsProp(alignment)} gap="s8">
          <Text.Header2>{label}</Text.Header2>
          {message && (
            <Box maxWidth={uploaded ? 'full' : 's400'} textAlign={alignment}>
              <Text.Normal>{message}</Text.Normal>
            </Box>
          )}
        </Box>

        {actionText && (
          <Button onClick={action} disabled={ctaDisabled}>
            {actionText}
          </Button>
        )}

        {withLine && <Line />}
      </Box>
    </Box>
  )
}

export default BlankSlate
